import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <p className="font-display text-[22vw] leading-none text-zinc-900 select-none">404</p>
      <h1 className="font-display text-4xl text-white uppercase tracking-tight -mt-8">Lost in the shadows</h1>
      <p className="text-zinc-500 mt-3">The page you're looking for doesn't exist.</p>
      <Link to="/" className="btn-accent mt-6 px-7 py-3.5 text-xs font-bold uppercase tracking-wider">Back Home</Link>
    </div>
  );
}
